// @ts-strict-ignore
import type { Action, ServiceAttributeMap, ServicesByName } from '../../types';

/**
 * get service attribute object using the given attribute id
 * services is from workflowProps, serviceAttributeData is provided from
 * the pasted data
 */
export function getAttributeObject({
  serviceAttributeData,
  services,
  attributeId,
}: {
  services: ServicesByName;
  serviceAttributeData?: ServiceAttributeMap;
  attributeId: number;
  sourceAction?: Action;
}) {
  const originalServiceName = serviceAttributeData[attributeId]?.service;
  const originalAttribute = serviceAttributeData[attributeId]?.attribute;
  return Object.values(
    services[originalServiceName].attributes).find(
    currentAttribute => {
      if (currentAttribute.attribute_name === originalAttribute?.attribute_name) {
        return currentAttribute;
      }

      if (currentAttribute.attribute_token
        && originalAttribute?.attribute_token
        && currentAttribute.attribute_token === originalAttribute?.attribute_token) {
        return currentAttribute;
      }

      return false;
    });
}


/**
 * get service attribute name using the given attribute id
 * and the service attribute object retrieved using the attribute id
 */
export function getAttributeName({
  serviceAttributeData,
  services,
  attributeId,
  sourceAction,
}: {
  services: ServicesByName;
  serviceAttributeData?: ServiceAttributeMap;
  attributeId: number;
  sourceAction?: Action;
}) {
  if (serviceAttributeData) {
    const attribute = getAttributeObject({
      serviceAttributeData,
      services,
      attributeId,
    });

    return attribute?.attribute_name;
  }

  const originalServiceName = sourceAction.service.internalName;
  return Object.entries(
    services[originalServiceName].attributes).find(
    currentAttribute => currentAttribute[1].attribute_id === attributeId)?.[1]?.attribute_name;
}
